import { render, staticRenderFns } from "./shopping.vue?vue&type=template&id=6795a79c&scoped=true"
import script from "./shopping.vue?vue&type=script&lang=js"
export * from "./shopping.vue?vue&type=script&lang=js"
import style0 from "./shopping.vue?vue&type=style&index=0&id=6795a79c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6795a79c",
  null
  
)

export default component.exports